/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';

import CardTooltip from '../../CardTooltip';
import Loading from '../../Loading';
import Icon from '../../Icons';

import { useGlobal } from '../../../contexts/Global/context';

import theme from '../../../styles/defaultTheme';

import * as S from './styles';
import * as Styles from '../styles';

function DatepickerMui({ field, loading, onChange, onBlur, icon: InputIcon, ...rest }) {
    const { contrastTheme } = useGlobal();

    const [isOpen, setIsOpen] = useState('');

    const [inputValue, setInputValue] = useState(field.value);

    const defaultCustomTheme = createTheme({
        palette: {
            primary: {
                main: '#FFFFFF',
            },
            action: {
                active: '#FFFFFF',
            },
            text: {
                hint: contrastTheme ? '#FFFFFF' : '#8A8A8A',
            },
        },
    });

    const defaultProps = {
        invalidDateMessage: '',
        maxDateMessage: '',
        minDateMessage: '',
        format: 'DD/MM/YYYY',
        placeholder: field.placeholder || 'DD/MM/AAAA',
        value: field.value || null,
        showToday: false,
        autoComplete: 'new-password',
        suffixIcon: (
            <Icon
                name="date_range"
                color={field.error && !contrastTheme ? '#EC130F' : contrastTheme ? '#FFF333' : '#EC6E0C'}
                size={20}
            />
        ),
    };

    function handleChange(value) {
        try {
            const treatedValue = value ? value.toISOString() : null;

            if (value && !value?.toISOString()) {
                throw new Error('Cannot convert this value to Date');
            }

            if (typeof onChange === 'function') onChange({ id: field.id, value: treatedValue, isValidDate: true });

            setInputValue(value);

            return true;
        } catch (error) {
            const treatedValue = inputValue ? moment(inputValue, 'DD/MM/YYYY').toISOString() : null;

            if (typeof onChange === 'function') onChange({ id: field.id, value: treatedValue, isValidDate: false });

            return error;
        }
    }

    function handleBlur(value) {
        try {
            const treatedValue = value ? moment(value).format('DD/MM/YYYY') : null;

            if (typeof onBlur === 'function') {
                onBlur({ target: { id: field.id, name: '', value: treatedValue, isValidDate: true } });
            }

            return true;
        } catch (error) {
            return error;
        }
    }

    useEffect(() => {
        if (isOpen === false) {
            handleBlur(inputValue);
        }
    }, [isOpen]);

    function renderDay(day, selectedDate, dayInCurrentMonth, dayComponent) {
        const styles = {
            day: {
                width: 36,
                height: 36,
                fontSize: theme.font.size12,
                margin: '0 2px',
                lineWeight: 12,
                fontWeight: dayComponent.props.hidden ? '' : 'bold',
                background: dayComponent.props.selected ? '#EC6E0C' : '',
                color: dayComponent.props.selected ? '#FFFFFF' : dayComponent.props.hidden ? '#5B5B5F' : '#000000',
            },
        };

        return (
            <div>
                <S.StyleIconButton
                    onClick={() => {
                        handleChange(day);

                        setIsOpen(false);
                    }}
                    style={styles.day}
                >
                    {moment(day).format('D')}
                </S.StyleIconButton>
            </div>
        );
    }

    return (
        <Styles.FormGroup>
            <label htmlFor="first-label">
                {field.label && `${field.label} ${!field.required && !field.disabled ? ' (opcional)' : ''}`}
                {field.help && (
                    <CardTooltip message={field.help}>
                        <Styles.ContainerHelp>
                            <Icon name="info" size={18} />
                        </Styles.ContainerHelp>
                    </CardTooltip>
                )}
            </label>

            <S.ContainerInput>
                {/* <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBRLocale}> */}
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
                    <ThemeProvider theme={defaultCustomTheme}>
                        <S.StyledDatepicker
                            autoOk
                            autoComplete="new-password"
                            className={`${field.error ? 'error' : ' '} ${field.disabled ? 'disabled' : ' '}`}
                            clearable
                            disabled={field.disabled}
                            inputVariant="outlined"
                            variant="inline"
                            keyboardIcon={
                                <Icon
                                    name="date_range"
                                    color={
                                        field.error && !contrastTheme
                                            ? '#EC130F'
                                            : contrastTheme
                                            ? '#FFF333'
                                            : '#EC6E0C'
                                    }
                                    size={20}
                                />
                            }
                            onChange={(date) => handleChange(date)}
                            id={field.id}
                            renderDay={renderDay}
                            open={isOpen}
                            onOpen={() => setIsOpen(true)}
                            onClose={() => setIsOpen(false)}
                            onBlur={({ target: { value } }) =>
                                handleBlur(value ? moment(value, 'DD/MM/YYYY').toISOString() : null)
                            }
                            {...defaultProps}
                            {...rest}
                        />
                    </ThemeProvider>
                </MuiPickersUtilsProvider>
                {loading && <Loading padding="0px" size={20} />}
                {!loading && InputIcon && (
                    <div className="icon-container">
                        <InputIcon color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                    </div>
                )}
            </S.ContainerInput>
            {field.error && <Styles.SpanError>{field.error}</Styles.SpanError>}
        </Styles.FormGroup>
    );
}

export default DatepickerMui;
